export const MENTION_ME_LANDING_PAGE = {
  DE: '/freunde-werben',
  FR: '/parrainage-proches',
  IT: '/codice-amico',
  NL: '/verwijs-een-vriend',
};
export const MENTION_ME_SCRIPT_ID = 'mentionMeScript';
export const MENTION_ME_CONTAINER_ID = 'mmWrapper';
